import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  materialsSlice,
  materialsState,
  material,
  glassPrice,
} from './MaterialsSlice';
import { addMaterialSlice } from './AddModal/AddModalSlice';
import MyDashbard from '../../components/Table/dashy_board';
// API
import API, { sortDirectionType } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import AddModal from './AddModal/AddModal';
import ShowMaterial from './ShowModal/ShowModal';

import { havePermission } from '../../services/hoc/permissions';
import { Col, Row } from 'react-grid-system';
import {
  AnimationButton,

} from '../../components/FormElements/FormElements';
import MaterialPricing from './MaterialPricing/MaterialPricing';
import {
  materialPricingSlice,
  materialPricingState,
} from './MaterialPricing/MaterialPricingSlice';
import EditMaterialPricing from './EditMaterialPricing/EditMaterialPricing';
import { editMaterialPricingSlice } from './EditMaterialPricing/EditMaterialPricingSlice';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useNotification } from '../../services/usenotification';

import { getListSort } from '../../services/hoc/sort';
import { RowContainer } from '../../components/Table/row_container';
import { SortTable } from '../../components/Table/SortTable';

import SettingContext from '../../services/context/setting-contentxt/setting-context';
import { Dispatch } from '@reduxjs/toolkit';
import DetailDrawer from '../../components/Drawer/Drawer';

import DeleteModalContext from '../../services/context/delete-modal/delete-modal-context';
import { iDeleteModal } from '../../services/context/delete-modal/delete-modal-provider';

import { useAPI } from '../../services/hoc/useAPI';

interface MaterialDetailProps {
  deleteService: Function;
  editService: Function;
  fetchData: Function;
  remove: Function;
  state: materialsState;
  dispatch: Dispatch;
  t: (par: string) => string;
  ENDPOINTS: API;
  addService: Function;
  columnWidth: number;
 
  removeMaterial:(material_id:number)=>void

}


//////////////////////// Details ///////////////////////////




const MaterialDetail = (props: MaterialDetailProps) => {
  

  return (
    <Col md={props.columnWidth}>
      <div
        style={{
          maxHeight: 'calc(100vh - 130px)',
          overflow: 'hidden auto',
          paddingBottom: '2rem',
        }}>
        <h1
          className="header"
          style={{
            fontSize: '28px',
            maxWidth: '400px',
            fontWeight: 500,
          }}>
          {props.state.material?.name}
        </h1>
        <div className="close-details-btn">
          <i
            className="icon-close"
            style={{ color: 'tomato', cursor: 'pointer' }}
            onClick={(e) => {
              props.dispatch(
                materialsSlice.actions.setMaterial({
                  showMaterial: false,
                }),

              );
            }}></i>
        </div>
        <div
          style={{
            borderSpacing: 0,
            borderCollapse: 'separate',
            width: '95%',
            borderBottom: '1px solid #D3D3D3',
          }}>
          <span
            style={{
              color: '#C5C5C5',
              textAlign: 'end',
              margin: '0 5px',
            }}>
            {props.t('serial_no')} :
          </span>
          <span style={{ textAlign: 'center' }}>
            {props.state.material?.code}
          </span>

          {/* <tr>
                        <td style={{ borderBottom: '1px solid #D3D3D3', color: '#C5C5C5' }}>{t('description')}</td>
                        <td style={{ borderBottom: '1px solid #D3D3D3', textAlign: 'end' }}>{state.material.description}</td>
                    </tr> */}
        </div>
        <h3 style={{ marginTop: '40px', marginBottom: '5px' }}>
          {props.t('services')}
        </h3>

        <MyDashbard
          header={[props.t('service'), props.t('code'), props.t('price')]}
          key_header={['gwname', 'gwcode', 'price']}
          deleteRow={
            havePermission('Delete Glass Work')
              ? props.deleteService
              : undefined
          }
          editRow={
            havePermission('Edit Glass Work') ? props.editService : undefined
          }
          hasMore={props.state.hasMore}
          loadMore={props.fetchData}
          data={props.state.glassPrices}
          this_for="service"
        />

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <AnimationButton
            label={props.t('edit_material')}
            disabled={!havePermission('Edit Glass')}
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              props.dispatch(addMaterialSlice.actions.setIsOpen(true));
              props.dispatch(addMaterialSlice.actions.setIsLoading(true));
              props.dispatch(
                addMaterialSlice.actions.setEditId(
                  props.state.material?.id ?? 0,
                ),
              );
              props.ENDPOINTS.glasses()
                .show({ id: props.state.material?.id ?? 0 })
                .then((response: any) => {
                  props.dispatch(
                    addMaterialSlice.actions.set({
                      // attributes: fixPredefinedFormat(response.data.data.attributes_list),
                      description: response.data.data.description,
                      name: response.data.data.name,
                      serial_number: response.data.data.code,
                      is_priced: response.data.data.is_priced,
                    }),
                  );
                  props.dispatch(addMaterialSlice.actions.setIsLoading(false));
                });
            }}
          />

          {props.state.material?.is_priced !== '0' && (
            <AnimationButton
              label={props.t('add_service')}
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                props.addService();
                props.dispatch(materialPricingSlice.actions.setIsOpen(true));
              }}
              disabled={!havePermission('Add Glass Work')}
            />
          )}
          <AnimationButton
            className="danger"
            label={props.t('delete_material')}
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              props.removeMaterial(props.state.material?.id??0)
            }}
            //  setOpenDeleteModal(pre=>({...pre,open:true,
            //   remove:()=>props.remove(props.state.material?.id)}))
            // }}
            disabled={!havePermission('Delete Glass')}
          />
        </div>
      </div>
     
    </Col>
  );
};





//////////////////////// Main Interface /////////////////////////////////







export default () => {
  // Translation
  const [openDetailDrawer, setOpenDetailDrawer] = useState(false);
  const {setOpenDeleteModal} =useContext(DeleteModalContext)
  const t = useTranslation();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });

  const [modal, setModal] = useState({ openShowMaterial: false });
 const keyword_ref = useRef<string|null>(null)
  const location = useLocation();
  const { alertError500 } = useNotification();
  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { materials: materialsState }) => state.materials,
  );
  const pricingState = useSelector(
    (state: { material_pricing: materialPricingState }) =>
      state.material_pricing,
  );

  // Hooks
  

  const { isPc } = useContext(SettingContext);
const ENDPOINTS = useAPI()

  const showMaterilRemoveModal=(material_id:number)=>{
    setOpenDeleteModal((pre:iDeleteModal)=>({...pre,open:true,remove:()=>remove(material_id)}))
  }

  // Search
  const search = (value: string) => {
    dispatch(materialsSlice.actions.reset());
       keyword_ref.current=Boolean(value)?value:null
    fetchData(1, Boolean(value) ? 20 : 8, value);
  };

  // Fetch Data
  const fetchData = useCallback((   page: number
                      , page_size: number = 8
                      , keyword: string
                      , sort_field? :number
                      , sort_direction?:sortDirectionType
                     ) => {
    dispatch(materialsSlice.actions.setIsFetching(true));
keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.glasses()
      .index({
        page,
        page_size,
        keyword,
        sort_direction,
        sort_field,
      })
      .then((response: any) => {
        dispatch(materialsSlice.actions.setIsFetching(false));
        dispatch(materialsSlice.actions.setPage(pagesInfo.page));
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));

        let materials: material[] = response.data.data.glasses.map(
          (material: any): material => ({
            id: material.id,
            description: material.description,
            name: material.name,
            code: material.code,
            ...material,
          }),
        );

        dispatch(materialsSlice.actions.initializeMaterials(materials));
        dispatch(
          materialsSlice.actions.setMaterial({
            showMaterial: true,
            material: materials[0],
          }),
        );
        dispatch(
          materialsSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );

        if (!state.isLoaded) dispatch(materialsSlice.actions.setIsLoaded(true));
        dispatch(materialsSlice.actions.setIsFetching(false));
      })
      .catch((err: any) => {
        dispatch(materialsSlice.actions.setIsFetching(false));
        alertError500(err);
      });
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData =useCallback ((
    sort_field: number,
    sort_direction: sortDirectionType,
  ) => {
    if (sort_direction && sort_field) {
        fetchData(
        state.page,
        8,
        '',
         sort_field,
         sort_direction,
      );
    }
  },[state.page])

  // Fetch Services
  const fetchServices = (id: number) => {
    dispatch(materialsSlice.actions.setIsLoading(true));

    ENDPOINTS.pricing()
      .selectByGlasses({ glass_id: id ,page:1,page_size:100,sort_field:35,sort_direction:'ASC'})
      .then((response: any) => {
        let glassPrices: glassPrice[] = response.data.data;

        dispatch(materialsSlice.actions.addGlassPrices(glassPrices));
        dispatch(materialsSlice.actions.setIsLoading(false));
      });
  };



  const actions = (material: material) => (
    <div className="show-on-hover">
      {havePermission('Show Glass') && (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              fetchServices(material.id);
              // dispatch(showMaterialSlice.actions.setIsOpen({ id: material.id, isOpen: true }))
              dispatch(
                materialsSlice.actions.setMaterial({
                  showMaterial: true,
                  material: material,
                }),
              );
              dispatch(materialPricingSlice.actions.setMaterial(material));
              if (!isPc) {
                setOpenDetailDrawer(true);
              }
            }}
          />
        </Tooltip>
      )}

      {havePermission('Edit Glass') && (
        <Tooltip title={t('edit')}>
          <i
            className="icon-edit"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
             
              dispatch(addMaterialSlice.actions.setIsOpen(true));
              dispatch(addMaterialSlice.actions.setIsLoading(true));
              dispatch(addMaterialSlice.actions.setEditId(material.id));
              ENDPOINTS.glasses()
                .show({ id: material.id })
                .then((response: any) => {
                  dispatch(
                    addMaterialSlice.actions.set({
                      // attributes: fixPredefinedFormat(response.data.data.attributes_list),
                      description: response.data.data.description,
                      name: response.data.data.name,
                      serial_number: response.data.data.code,
                      is_priced: response.data.data.is_priced,
                    }),
                  );
                  dispatch(addMaterialSlice.actions.setIsLoading(false));
                });
            }}
          />
        </Tooltip>
      )}

      {havePermission('Delete Glass') && (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              setOpenDeleteModal((pre:iDeleteModal)=>
              ({...pre,open:true
                ,remove:()=>remove(material.id)
                ,message: t('delete_confirmation')
              }))
              // Confirm({
               
              //   message: t('delete_confirmation'),
              //   onConfirm: () => remove(material.id),
              // });
            }}
          />
        </Tooltip>
      )}
    </div>
  );
  const rows = () => {
    return state.materials[state.page]
      ? state.materials[state.page]!.map((material, index) => {
          return (
            <RowContainer
            key={index}
              item_id={material.id.toString()}
              state_length={state.materials[state.page]?.length as number}
              tr_index={index}
              onSelect={toggleSelectedId}
              columns={[material.code, material.name, actions(material)]}
            />
          );
        })
      : null;
  };
  const editService = (glassPrice: any) => {
    dispatch(editMaterialPricingSlice.actions.setIsOpen(true));
    dispatch(editMaterialPricingSlice.actions.setGlassPrice(glassPrice));
    dispatch(
      editMaterialPricingSlice.actions.set({
        glass_id: glassPrice.gid,
        glass_work_id: glassPrice.gwid,
        id: glassPrice.pid,
        price: `${glassPrice.price}`,
      }),
    );
  };
  const deleteService = (glassPrice_pid: number) => {
   
    setOpenDeleteModal((pre:iDeleteModal)=>({...pre,open:true
      ,remove:()=>removePrice(glassPrice_pid)
        ,message:t('delete_confirmation')
        ,drawer_parent:false
      }
        ))
    // Confirm({
    //   message: t('delete_confirmation'),
    //   onConfirm: () => removePrice(glassPrice_pid),
    // });
  };
  const addService = () => {
    if (pricingState.prices.length === 0) {
      dispatch(
        materialPricingSlice.actions.set([
          { price: '0', glass_id: `${state.material?.id}` },
        ]),
      );
    } else {
      dispatch(
        materialPricingSlice.actions.set([
          { price: '0', glass_id: `${state.material?.id}` },
        ]),
      );
    }
  };
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Glass')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(materialsSlice.actions.setIsLoading(true));
    ENDPOINTS.glasses()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(materialsSlice.actions.setIsLoading(false));
        dispatch(materialsSlice.actions.deleteMaterials(ids));
      })
      .catch((error: any) => {
        alertError500(error);
        dispatch(materialsSlice.actions.setIsLoading(false));
      });
  };

  // Delete
  const removePrice = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(materialsSlice.actions.setIsLoading(true));
    ENDPOINTS.pricing()
      .deletePrices({ ids })
      .then(() => {
        dispatch(materialsSlice.actions.setIsLoading(false));
        dispatch(materialsSlice.actions.deleteGlassPrices(ids[0]));
      })
      .catch((error: any) => {
        alertError500(error);
        dispatch(materialsSlice.actions.setIsLoading(false));
      });
  };

  // First fetch
  useEffect(() => {
    if (!state.isFetching) {
      fetchData(1, 8, location.state?.key ?? '',33,'ASC');
    }
  }, []);
  /////////////////////// initial view ////////
  useEffect(() => {
    if (!state.isFetching && !state.isLoaded) {
      if (
        state.materials &&
        state.materials[state.page] &&
        state.materials[state.page]!.length > 0 &&
        havePermission('Show Pricing')
      ) {
        fetchServices(state.materials[state.page]![0].id);

        dispatch(
          materialsSlice.actions.setMaterial({
            showMaterial: true,
            material: state.materials[state.page]![0],
          }),
        );
        dispatch(
          materialPricingSlice.actions.setMaterial(
            state.materials[state.page]![0],
          ),
        );
      }
    }
  }, [state.material, state.materials[state.page], state.isFetching]);

  useEffect(() => {
    if (state.showMaterial) {
      // dispatch(materialsSlice.actions.setMaterial({
      //   showMaterial:false,
      //   material:undefined
      // }))
      if (
        state.materials[state.page]![0] &&
        state.materials[state.page]![0].id &&
        havePermission('Show Pricing')
      )
        fetchServices(state.materials[state.page]![0].id);
    }
  }, [state.showMaterial]);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        materialsSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page, 8, location.state?.key ?? '');
      }
    }
  }, [pagesInfo.page]);

  // useEffect(() => {
  //   if (sortOptions?.sort_direction && sortOptions.sort_field) {
  //     fetchData(state.page, 8, '');
  //   }
  // }, [sortOptions?.sort_direction, sortOptions?.sort_field]);



  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading && !openDetailDrawer ? <WhiteboxLoader /> : ''}
          <Row>
            <Col
              md={
                isPc &&
                havePermission('Show Glass') &&
                havePermission('Show Pricing') &&
                state.showMaterial &&
                state.material?.id &&
                state.material.id > 0
                  ? 6
                  : 12
              }>
              <div
                style={{
                  maxHeight: 'calc(100vh - 130px)',
                  overflow: 'hidden auto',
                }}>
                <TableActionBar
                  keyword={location.state?.key ?? ''}
                  title={t('materials')}
                  search={search}
                  showFilter={false}
                  showDelete={selectedIds.length > 0}
                  delete={() => {
                    setOpenDeleteModal((pre:iDeleteModal)=>({
                      ...pre,open:true,message:t('delete_confirmation'),
                      remove:() => remove()
                    }))
                    // Confirm({
                    //   message: t('delete_confirmation'),
                    //   onConfirm: () => remove(),
                    // });
                  }}
                  addText={t('add_to_materials')}
                  add={
                    havePermission('Add Glass')
                      ? () => dispatch(addMaterialSlice.actions.setIsOpen(true))
                      : undefined
                  }
                />

           
                <SortTable
                  header={[t('serial_number'), t('name'), '']}
                  header_cell_width={['25%', '50%', '25%']}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={() => {}}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  state={state.materials[state.page] ?? []}
                  sort_fields={getListSort(['code', 'name', 'price'], 'Glass')}
                  fetchSortedData={fetchSortedData}>
                  <>{rows()}</>
                </SortTable>
              </div>
              <div></div>
            </Col>

            {havePermission('Show Glass') &&
            state.showMaterial &&
            state.material != null ? (
              isPc ? (
                <MaterialDetail
                  ENDPOINTS={ENDPOINTS}
                  addService={addService}
                  deleteService={deleteService}
                  dispatch={dispatch}
                  editService={editService}
                  fetchData={fetchData}
                  remove={remove}
                  t={t}
                  state={state}
                  columnWidth={6}
                  removeMaterial={showMaterilRemoveModal}
                />
              ) : (
                <DetailDrawer
                  openDetailDrawer={openDetailDrawer}
                  setOpenDetailDrawer={setOpenDetailDrawer}>
                  <>
                  {state.isLoading && openDetailDrawer ? <WhiteboxLoader /> : ''}
                    <MaterialDetail
                      ENDPOINTS={ENDPOINTS}
                      addService={addService}
                      deleteService={deleteService}
                      dispatch={dispatch}
                      editService={editService}
                      fetchData={fetchData}
                      remove={remove}
                      t={t}
                      state={state}
                      columnWidth={12}
                       removeMaterial={showMaterilRemoveModal}
                    />

                    <AddModal />

                    <MaterialPricing addService={addService} />

                    <EditMaterialPricing />
                    <>
                      {modal.openShowMaterial && (
                        <ShowMaterial
                          close={() =>
                            setModal((pre) => ({
                              ...pre,
                              openShowMaterial: false,
                            }))
                          }
                        />
                      )}
                    </>
                  </>
                </DetailDrawer>
              )
            ) : null}
          </Row>
          {!openDetailDrawer && (
            <>
          
             <AddModal />

              <MaterialPricing addService={addService} />

              <EditMaterialPricing />
              <>
                {modal.openShowMaterial && (
                  <ShowMaterial
                    close={() =>
                      setModal((pre) => ({ ...pre, openShowMaterial: false }))
                    }
                  />
                )}
              </>
            </>
          )}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
